// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 27) return "static/js/9550e69c40e4e65b1797.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"c52eb8a3d25f02c0f15f","125":"109f83b0e0e86f0d4d1e","126":"a21c993b1e173cdd420d"}[chunkId] + ".chunk.js";
};